<div class="login-container">
    <div class="layerTop">
        <img src="../../../assets/images/layerTop.png" alt="">
    </div>
    <div class="loginForm">
        <div class="loginForm">
            <div class="formWrapp">
                <h2>Reset Your Password</h2>
                <div class="formFeilds wrappInside">
                    <form [formGroup]="passwordResetForm">
                        <div class="formGroup">
                            <label>New Password</label>
                            <mat-form-field appearance="outline">
                                <input id="login_module_reset_password_1" matInput placeholder="Enter your Password" formControlName="password" [type]="hide ? 'password' : 'text'">
                                <mat-icon matSuffix (click)="togglePasswordVisibility()">
                                    {{ hide ? 'visibility_off' : 'visibility' }}
                                </mat-icon>
                            </mat-form-field>
                            <span class="validation-error errorTxt"
                            *ngIf="(formSubmitted || passwordResetForm.controls['password'].touched)  && passwordResetForm.controls['password'].errors?.['required']">New password is required
                            is required</span>
                        </div>
                        <div class="formGroup">
                            <label>Confirm Password</label>
                            <mat-form-field appearance="outline">
                                <input id="login_module_reset_password_2" matInput placeholder="Enter your Password" formControlName="confirmPassword" [type]="cHide ? 'password' : 'text'">
                                <mat-icon matSuffix (click)="toggleConfirmPasswordVisibility()">
                                    {{ cHide ? 'visibility_off' : 'visibility' }}
                                </mat-icon>
                            </mat-form-field>
    
                            <span class="validation-error errorTxt"
                            *ngIf="(formSubmitted || passwordResetForm.controls['password'].touched)  && passwordResetForm.controls['password'].errors?.['required']">
                            Confirmed password is required</span>
    
                            <span class="validation-error errorTxt"
                            *ngIf="(formSubmitted || passwordResetForm.controls['confirmPassword'].touched)  && passwordResetForm.controls['confirmPassword']?.value !== passwordResetForm.controls['password']?.value">Confirm password and password should be same</span>
                           
                        </div>
                        <div class="formGroup mt-24">
                            <button id="login_module_reset_password_3" mat-button color="primary" type="button" class="primaryButton"
                            (click)="submit()"
                            [ngClass]="{'disable': !passwordResetForm.valid || 
                            (formSubmitted || passwordResetForm.controls['confirmPassword'].touched || passwordResetForm.controls['confirmPassword'].dirty) 
                             && passwordResetForm.controls['confirmPassword'].value !== passwordResetForm.controls['password'].value}">Create Password</button>
                        </div>
                        <div class="passwordMath">
                            <p>Password must contain:</p>
                            <ul>
                                <li class="validation-error" [ngClass]="hasError('minlength') ? 'notmatched' : passwordResetForm.controls['password'].value == '' ? 'notmatched' : 'matched' ">
                                    <mat-icon class="match-mini">remove</mat-icon>
                                    <mat-icon class="match-done">done</mat-icon>
                                    More than 8 characters
                                </li>
                                <li class="validation-error" [ngClass]="hasError('hasUppercase') ? 'notmatched' : passwordResetForm.controls['password'].value == '' ? 'notmatched' : 'matched'">
                                    <mat-icon class="match-mini">remove</mat-icon>
                                    <mat-icon class="match-done">done</mat-icon>
                                    Contains uppercase letter(A-Z)
                                </li>
                                <li class="validation-error" [ngClass]="hasError('hasLowercase') ? 'notmatched' : passwordResetForm.controls['password'].value == '' ? 'notmatched' : 'matched'">
                                    <mat-icon class="match-mini">remove</mat-icon>
                                    <mat-icon class="match-done">done</mat-icon>
                                    Contains lowercase letter(a-z)
                                </li>
                                <li class="validation-error" [ngClass]="hasError('hasNumber')? 'notmatched' : passwordResetForm.controls['password'].value == '' ? 'notmatched' : 'matched'">
                                    <mat-icon class="match-mini">remove</mat-icon>
                                    <mat-icon class="match-done">done</mat-icon>
                                    Contains at least one number(0-9)
                                </li>
                                <li class="validation-error" [ngClass]="hasError('hasSpecialCharacter') ? 'notmatched' : passwordResetForm.controls['password'].value == '' ? 'notmatched' : 'matched'">
                                    <mat-icon class="match-mini">remove</mat-icon>
                                    <mat-icon class="match-done">done</mat-icon>
                                    Contains at least one symbol(*,$,#,etc)
                                </li>
                           </ul>
                         </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>